var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "data-list",
    style: _vm.style,
    attrs: {
      "tag": "dl"
    }
  }, [_vm.dataList.length ? _vm._l(_vm.dataList, function (_ref, i) {
    var term = _ref.term,
        description = _ref.description,
        _ref$cols = _ref.cols,
        cols = _ref$cols === void 0 ? 12 : _ref$cols,
        _ref$isPreLine = _ref.isPreLine,
        isPreLine = _ref$isPreLine === void 0 ? false : _ref$isPreLine;
    return _c('v-col', {
      key: "description-".concat(i),
      staticClass: "py-0",
      attrs: {
        "tag": "li",
        "cols": cols
      }
    }, [_c('dt', {
      class: {
        isPreLine: isPreLine
      }
    }, [_vm._v(_vm._s(term))]), _c('dd', {
      class: {
        isPreLine: isPreLine
      }
    }, [_vm._v(_vm._s(description))])]);
  }) : !_vm.disableNoneMessage ? [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "tag": "li",
      "cols": "12"
    }
  }, [_vm._v(" 자료가 없습니다. ")])] : _vm._e(), _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }